// extracted by mini-css-extract-plugin
export default {"contenedor":"EntregaView_contenedor__KmPEL","header":"EntregaView_header__3YBuY","error":"EntregaView_error__fslSI","alerta":"EntregaView_alerta__m6nFg"};